<script lang="ts">
	import { isMobileMenuOpen } from '../store/navigation'

const handleClick = () => {
  isMobileMenuOpen.set(!$isMobileMenuOpen)
}
</script>

<button class="text-gray-500 w-10 h-10 relative focus:outline-none bg-white md:hidden" on:click={handleClick}>
  <span class="sr-only">Open main menu</span>
  <div class="block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <span 
        aria-hidden="true"
        class="block absolute h-0.5 w-5 bg-current transform transition duration-300 ease-in-out {$isMobileMenuOpen ? 'rotate-45' : '-translate-y-1.5'}">
      </span>
      <span 
        aria-hidden="true" 
        class="block absolute h-0.5 w-5 bg-current transform transition duration-300 ease-in-out {$isMobileMenuOpen ? 'opacity-0' : ''}">
      </span>
      <span 
        aria-hidden="true" 
        class="block absolute h-0.5 w-5 bg-current transform  transition duration-3 00 ease-in-out {$isMobileMenuOpen ? '-rotate-45' : 'translate-y-1.5'}">
      </span>
  </div>
</button>